import { MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "19146730325";
const WHATSAPP_MESSAGE = encodeURIComponent("Hola Oymer, me interesa conocer más sobre los productos Vida Divina");

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white rounded-full w-14 h-14 flex items-center justify-center shadow-[0_8px_20px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110 animate-float"
      aria-label="Contactar por WhatsApp"
    >
      <MessageCircle size={28} strokeWidth={1.5} />
    </a>
  );
}
